import axios from "axios";
import qs from "qs";
import includes from "lodash/includes";

export default {
  state: {
    vehicles: [],
    assets: [],
    cabinets: [],
    vehicle_types: [],
    vehicle_type: [],
    get_vehicles: [],
    cabinet_loaded: false,
  },
  getters: {
    getVehiclesData(state) {
      return state.vehicles;
    },
    getVehicleType(state) {
      return state.vehicle_type;
    },
    getVehicles(state) {
      return state.get_vehicles;
    },
    getCabinets(state) {
      return state.cabinets;
    },
    getCabinetLoaded(state) {
      return state.cabinet_loaded;
    },
  },
  mutations: {
    CLEAR_VEHICLE_TYPES_DATA(state) {
      state.vehicle_types.splice(0);
    },
    CLEAR_VEHICLE_TYPE(state) {
      state.vehicle_type.splice(0);
    },
    CLEAR_CABINETS(state) {
      state.cabinets.splice(0);
    },
    ADD_VEHICLE_TYPES_DATA(state, payload) {
      state.vehicle_types = payload;
    },
    ADD_VEHICLE_TYPE_DATA(state, payload) {
      state.vehicle_type = payload;
    },
    ADD_VEHICLES_DATA(state, data) {
      state.vehicles = data;
    },
    ADD_ASSETS_DATA(state, data) {
      state.assets = data;
    },
    ADD_VEHICLES(state, data) {
      state.get_vehicles = data;
    },
    ADD_CABINET_TO_LIST(state, cabinet) {
      state.cabinets.push(cabinet);
    },
    SET_CABINET_LOADED(state, loaded) {
      state.cabinet_loaded = loaded;
    },
  },
  actions: {
    LOAD_AVAILABLE_VEHICLES({ commit, rootState }, payloads) {
      const {
        origin,
        destination,
        start_date,
        end_date,
        find_shared,
      } = payloads;

      return axios
        .post(
          `${process.env.VUE_APP_API_URL}/get_available_vehicles`,
          qs.stringify({
            token: rootState.token,
            clientid: rootState.clientid,
            origin,
            destination,
            start_date,
            end_date,
            find_shared,
          })
        )
        .then((response) => {
          if (response !== null) {
            commit("ADD_VEHICLES_DATA", response.data.data);
          }
        })
        .catch((error) => {
          return error;
        });
    },
    LOAD_AVAILABLE_ASSETS({ commit, rootState }, payloads) {
      const {
        origin,
        destination,
        start_date,
        end_date,
        find_shared,
        type,
      } = payloads;
      return axios
        .post(
          `${process.env.VUE_APP_API_URL}/get_available_assets`,
          qs.stringify({
            token: rootState.token,
            clientid: rootState.clientid,
            origin,
            destination,
            start_date,
            end_date,
            find_shared,
            type,
          })
        )
        .then((response) => {
          if (response !== null) {
            commit("ADD_ASSETS_DATA", response.data.data);
          }
        })
        .catch((error) => {
          return error;
        });
    },
    LOAD_VEHICLE_TYPES({ commit, rootState }) {
      const { token, clientid } = rootState;
      const query = qs.stringify({ token, clientid });
      const url = `${process.env.VUE_APP_API_URL}/get_vehicles`;
      return axios.post(url, query).then((response) => {
        if (response) {
          const {
            data: { data: vehicles },
          } = response;
          const vehicle_types = vehicles.reduce((arr, vehicle) => {
            if (includes(arr, vehicle.type_name) == false)
              arr.push(vehicle.type_name);
            return arr;
          }, []);
          commit("ADD_VEHICLE_TYPES_DATA", vehicle_types);
          commit("ADD_VEHICLES", vehicles);
        }
      });
    },
    LOAD_VEHICLE_TYPE({ commit, rootState }) {
      const { token, clientid } = rootState;
      const query = qs.stringify({ token, clientid });
      const url = `${process.env.VUE_APP_API_URL}/get_vehicle_types`;
      return axios.post(url, query).then((response) => {
        if (response !== null) {
          commit("ADD_VEHICLE_TYPE_DATA", response.data.data);
        }
      });
    },
    LOAD_CABINETS({ commit, rootState }) {
      const { token } = rootState;
      const query = qs.stringify({ token });
      const url = `${process.env.VUE_APP_API_URL}/get_cabinets`;
      return axios.post(url, query)
        .then((response) => {
          if (response) {
            commit('SET_CABINET_LOADED', true);
            const { cabinets } = response.data.data;
            cabinets.forEach((cabinet) => {
              commit('ADD_CABINET_TO_LIST', cabinet);
            });
          }
        });
    },
  },
};
